/* tslint:disable */
/* eslint-disable */
/**
 * Magnolia Headless Helper API
 * Helper API and model definitions for breadcrumbs page navigation etc. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
* 
* @export
* @interface ApiPage
*/
export interface ApiPage {
    /**
    * 
    * @type {string}
    * @memberof ApiPage
    */
    title: string;
    /**
    * 
    * @type {boolean}
    * @memberof ApiPage
    */
    breadCrumbs: boolean;
    /**
    * 
    * @type {string}
    * @memberof ApiPage
    */
    url: string;
}

export function ApiPageFromJSON(json: any): ApiPage {
return ApiPageFromJSONTyped(json, false);
}

export function ApiPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPage {
    if ((json === undefined) || (json === null)) {
    return json;
    }
    return {
    
                    'title': json['title'],
                    'breadCrumbs': json['breadCrumbs'],
                    'url': json['url'],
        };
    }

    export function ApiPageToJSON(value?: ApiPage | null): any {
    if (value === undefined) {
    return undefined;
    }
    if (value === null) {
    return null;
    }
    return {

                'title': value.title,
                'breadCrumbs': value.breadCrumbs,
                'url': value.url,
    };
    }


    // custom code here ##################################################################################################################
    // function toUTC(date) {
    //   var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
    //   return new Date(date_utc);
    // }

